var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'hab-flex',
    {
      [`${_vm.className}`]: _vm.className,
      [`align-${_vm.align}`]: _vm.align,
      [`wrap-${_vm.wrap}`]: _vm.wrap,
      [`direction-${_vm.direction}`]: _vm.direction,
      [`justify-${_vm.justify}`]: _vm.justify,
      [`gap-${_vm.gap}`]: _vm.gap,
    },
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }